export default {
    word: {
        hello: '你好',
        voices: '声音',
        fans: '粉丝',
        amounts: '数量',
        none: '无',
        unlisten: '未听',
        switch: '换一批',
        ok: '确定',
        agree: '同意',
        close: '关闭',
        cancel: '取消',
        invite: '邀请',
        back: '返回',
        tips: '提示',
        anchor: '主播',
        writer: '作家',
        mobileVersionLink: '手机版',
        register: '注册',
        login: '登录',
        logout: '注销',
        homePage: '首页',
        chooseLabel: '请选择',
        prevStep: '上一步',
        nextStep: '下一步',
        published: '已出版',
        unpublished: '未出版',
        publisher: '出版社',
        detail: '详情',
        favourite: '收藏',
        message: '消息',
        vacate: '请假',
        notify: '通知',
        unprocessed: '待处理',
        total: '共',
        item: '条',
        offWorker: '请假人',
        suspendWork: '请假作品',
        suspendTime: '请假时间',
        from: '从',
        to: '到',
        day: '天',
        check: '查看',
        status: '状态',
        refuse: '拒绝',
        error: '错误',
        delete: '删除',
        add: '添加',
        filter: '筛选',
        all: '全部',
        toBeCommit: '待提交',
        addition: '海选中',
        selecting: '选拔中',
        inProduction: '制作中',
        finished: '已完结',
        type: '分类',
        edit: '编辑',
        minute: '分钟',
        people: '人',    // 量词单位
        noLimit: '不限',
        single: '单人',
        doubleMix: '男女双人',
        multipleNovelDrama: '多人小说剧',
        multipleRadioDrama: '多人广播剧',
        disagree: '不同意',
        evaluate: '评价',
        uploadBreak: '断更',
        times: '次',
        toBeAudit: '待审核',
        wordCount: '字数',
        release: '发布',
        download: '下载',
        episode: '集',
        auditing: '审核中',
        toBeRelease: '待发布',
        released: '已发布',
        by: '由',
        recite: '演播',
        passAudit: '已审核',
        fixedPrice: '一口价',
        basePrice: '底薪',
        sharePay: '分成',
        bookList: '书单',
        wechat: '微信号',
        website: '官网',
        verifyCode: '验证码',
        iAm: '我是',
        apply: '申请',
        signIn: '入驻',
        toBePaid: '待支付',
        withDrew: '撤销',
        order: '订单',
        paid: '已支付',
        refund: '退款',
        announcement: '公告',
        popularize: '推广',
        magnumOpus: '代表作',
        pseudonym: '笔名',
        todo: '待办',
        handle: '处理',
        replace: '替换',
        demo: '模板',
        solo: '独家',
        preview: '预览',
        acceptance: '验收中',
    },
// {{ $t('word.demo') }}
// this.$i18n.t('word.paid')
    comb: {
        voicesAmounts: '声音数量',
        fansAmounts: '粉丝数量',
        inviteAnchor: '邀请主播',
        invitationRefuse: '邀约被拒',
        sendInvitation: '发送邀约',
        invitationSent: '已发邀约',
        sendAgain: '再次发送',
        anchor: '我是主播',
        writer: '我是作家',
        publisher: '我是出版社',
        homePageLink: '喜马拉雅FM首页',
        anchorAuthLink: '主播V认证',
        anchorCollegeLink: '主播大学',
        backToMainPage: '返回主页面',
        alreadyBindMobile: '已绑定手机号',
        bindMobile: '绑定手机',
        realName: '真实姓名',
        IDNumber: '身份证号',
        emailAddress: '邮箱地址',
        workName: '作品名称',
        workType: '作品分类',
        uploadCover: '上传封面',
        uploadAuthImg: '上传认证',
        commitToAudit: '提交审核',
        reSignIn: '重新入驻',
        uploadWork: '上传版权内容',
        uploadCopyrightFile: '上传版权文件',
        uploadedWorkList: '上传的作品',
        releasedTask: '任务管理',
        handle: '去处理',
        auditOnLeave: '请假审核',
        additionalRemarks: '补充说明',
        commitTime: '提交时间',
        messageCenter: '消息中心',
        workUpload: '作品上传',
        dealDetail: '协议详情',
        successfullyChanged: '修改成功',
        successfullyCreated: '创建成功',
        successfullyDeleted: '删除成功',
        checkAnchorDetail: '查看主播',
        checkWorkDetail: '查看作品',
        checkRequirement: '查看任务',
        anchorShare: '主播分成',
        taskInfo: '任务信息',
        taskRequirement: '任务要求',
        recruitmentAmount: '招募人数',
        releaseMode: '发布方式',
        taskFinished: '任务完结',
        prolongPeriodOfAddition: '延长海选',
        warmTips: '温馨提示',
        operationSuccess: '操作成功',
        signUser: '签约用户',
        checkEvaluate: '查看评价',
        contractTime: '签约时间',
        voiceWork: '声音作品',
        notPass: '不通过',
        AuditResult: '审核结果',
        passAudit: '审核通过',
        notPassAudit: '审核不通过',
        failedAudit: '审核失败',
        recordQuality: '录音质量',
        serviceAttitude: '服务态度',
        responseSpeed: '响应速度',
        taskEvaluate: '任务评价',
        breakRecord: '断更记录',
        evaluateSuccessfully: '评价成功!',
        additionRequirement: '海选要求',
        recommendAnchor: '推荐主播',
        workIntro: '作品简介',
        workAttachment: '作品附件',
        authSnapshot: '认证截图',
        imgPreview: '图片预览',
        additionMaterial: '海选素材',
        additionCycle: '海选期限',
        releaseTask: '发布任务',
        baseInfo: '基本信息',
        baseRequirement: '说说基本需求',
        setRecruitmentType: '设置招募方式',
        confirmRequirement: '确认需求',
        workSelection: '作品选择',
        taskName: '任务名称',
        taskCategory: '任务分类',
        taskCover: '任务封面',
        taskIntro: '任务简介',
        taskType: '任务类型',
        linkedCopyright: '关联版权',
        updateFrequency: '更新频率',
        taskPay: '任务酬劳',
        recruitmentType: '招募方式',
        additionAnchor: '海选主播',
        anchorName: '主播名称',
        displayWay: '演绎方式',
        detailRequirement: '详细要求',
        taskSalary: '任务薪酬',
        oneEpisodePerDay: '每天1集',
        twoEpisodePerDay: '每天2集',
        threeEpisodePerDay: '每天3集',
        oneEpisodeEveryTwoDays: '两天1集',
        oneEpisodePerWeek: '每周1集',
        copyrightWorkManagement: '版权管理',
        dataAnalysis: '数据分析',
        uploadCover: '添加封面',
        minimumPrice: '最低定价',
        maximumPrice: '最高定价',
        uploadMore: '上传更多',
        giveUpBook: '放弃上传',
        commitConfirm: '确认提交',
        timeLine: '时间线',
        transcribed: '已录制',
        buyAmount: '订阅数',
        played: '播放量',
        fullyPlayRate: '完播率',
        workPrice: '作品定价',
        authFile: '认证文件',
        goodAt: '擅长类型',
        startRecord: '开始录制',
        prospectiveEarning: '预期收益',
        phoneNumber: '联系电话',
        phoneNumber1: '联系电话1',
        phoneNumber2: '联系电话2',
        address: '联系地址',
        cooperationComment: '合作说明',
        publisherName: '出版社名称',
        licenseNumber: '工商注册号码',
        workFile: '作品内容附件列表',
        authorization: '授权信息',
        amountOfEpisode: '专辑集数',
        toPay: '去支付',
        anchorIncome: '主播收益',
        anchorPay: '主播酬劳',
        albumManagement: '专辑管理',
        albumOnSale: '专辑上架',
        voicePrice: '声音单价',
        voiceDiscountPrice: '折扣价',
        freeEpisode: '试听集数',
        albumPricing: '专辑定价',
        albumRePricing: '专辑调价',
        personalIntro: '个人简介',
        orderDetail: '订单详情',
        taskAnchor: '任务主播',
        haveRead: '已阅读',
        licenseAgreement: '授权协议',
        copyrightInfo: '版权信息',
        earningDetail: '收益明细',
        toFindTask: '去找任务',
        myVoiceTag: '声音标签',
        myAudioBook: '我的有声书',
        myAuditionTask: '海选任务',
        myAudition: '我的海选',
        myTask: '我的任务',
        AuditionFailure: '海选失败',
        accountRegister: '注册账户',
        todo: '待办事项',
        invitationProcess: '处理邀约',
        auditFailure: '审核不合格',
        taskUpdate: '任务更新',
        toHandle: '去处理',
        copyrightOrgnization: '版权机构',
        licenseBook: '授权书',
        acceptanceRejection: '验收未通过'
    },
// {{ $t('comb.accountRegister') }}
// this.$i18n.t('comb.additionCycle')
    sen: {
        chooseAnotherAnchor: '推荐其他主播',
        successfullyToSendInvitation: '发送邀请成功',
        chooseAnchor: '请选择一个主播',
        anchorInvitationConfirm: '确认邀请主播',
        homePage1: '传播优质的声音和作品',
        homePage2: '版权保护，持续受益，实时互动，智慧分析',
        backToPrevPageConfirm: '确认返回上一页',
        realNamePlaceHolder: '请填写身份证上的真实信息',
        IDNumberPlaceHolder: '作品有声化平台不会在未经允许的情况下透露给第三方您的身份证号',
        emailPlaceHolder: '您的常用邮箱',
        goodAtType: '您擅长的写作类型',
        pictureUploadLimit: '（图片大小5M以内，图片格式只能为：jpg、png、bmp）',
        uploadPictureWithLicence: '上传手持证件照',
        keyInYourIDNumber: '请输入身份证号',
        errorInIDNumber: '身份证号码不能大于100位',
        wordOnlyInName: '作家名字只能包含中文和英文',
        bindMobilePlease: '请绑定手机',
        keyInYourNamePlease: '请输入您的名字',
        workNameLengthShouldLessThanFifty: '作品名称长度不能大于50个字符',
        uploadYourLicenceImgPlease: '请上传您的证件照',
        infoErrorRecommitPlease: '信息填写有误，请根据提示重新填写',
        bigIconSizeLimit: '大图标不能超过5M, 请重新上传!',
        workNameMissing: '请填写作品名称',
        chooseWorkType: '请选择作品分类',
        ISBNPlaceHolder: '请填写ISBN号',
        publisherHolder: '请填写作品的出版社',
        workDetailPlaceHolder: '请添加作品描述详情',
        authWorkReleaseDeal: '“授权文字发布协议”',
        upload4AuthImg: '上传四副截图：作品所属网站的个人信息页，章节页，作品首页，登录页',
        chooseTheTypeYouGoodAt: '请选择一个您擅长的类型',
        keyInYourEmailAddressPlease: '请输入您的邮件地址',
        syntaxErrorOfEmailAddress: '请填写正确的邮件地址',
        emailAddressLengthShouldLessThanOneFifty: '邮箱地址长度不超过150个字符',
        bookNameMissing: '请输入书籍名称',
        chooseBookTypePlease: '请选择书籍类型',
        publisherMissing: '请填写书籍所属出版社',
        publisherNameShouldLessThan1Hundred: '出版社名称长度不能大于100个字符',
        workDetailMissing: '请描述书籍详情',
        workDetailShouldLessThan2Thousand: '作品详情长度不能大于2000个字符',
        coverImgMissing: '请上传封面图片',
        previewFileMissing: '请上传试图文件',
        authImgMissing: '请上传认证图片',
        needAllAuthImg: '请上传所有认证图片',
        myCopyrightCenter: '我的版权中心',
        workNameMissing: '请输入作品名称',
        needToUploadWorksPlease: '请上传作品',
        permanentlyDeleteConfirm: '此操作将永久删除该任务，是否继续？',
        failedToProlongPeriodOfAddition: '海选延长失败',
        successfullyToProlongPeriodOfAddition: '海选成功延长',
        dayAmountShouldBeInteger: '天数必须是正整数',
        noNeedToRelease: '无需发布',
        anchorCreateFreeAlbum: '主播创建免费专辑',
        anchorCreateChargeAlbum: '主播创建付费专辑',
        specifyAlbum: '指定专辑',
        anchorCreatedAlbum: '主播已有专辑',
        writerRequireCreateFreeAlbum: '作家要求创建免费专辑',
        writerRequireCreateChargeAlbum: '作家要求创建付费专辑',
        finishTaskConfirm: '任务完结后签约的小伙伴无法再上传和更新作品，确定要完结任务吗？',
        anchorApplyFinish: '主播申请已完结',
        evaluateContentMissing: '请输入评价内容',
        noBreakRecord: '暂无断更记录',
        whyFailedToAuditPlease: '请输入审核失败原因',
        passVoiceAuditConfirm: '确认要通过该声音吗?',
        refuseFinishConfirm: '确认拒绝完结吗？',
        passFinishConfirm: '确认通过完结吗？',
        writerAlertInfo: '大家将根据海选素材演播5分钟的样品供您比稿，您可选择最满意的人进行签约，签约后作品由您审核通过再支付酬金',
        additionRequirementPlaceHolder: '根据提供的海选素材，任选一段进行演播，时长5分钟左右，建议挑选包含对话情节的内容进行演播',
        taskPeriodMissing: '请选择任务时长',
        additionRequirementShouldLessThan2Thousand: '海选要求的字数需要小于2000',
        chooseSpecifyWork: '请选择对应作品',
        taskNameMissing: '请输入任务名字',
        typeMissing: '请选择分类',
        anchorShareRate: '主播分成比例',
        moreThanPerEpisode: '一集不少于',
        chooseAnchorYouWant: '请选择想要邀请的主播',
        anchorPayRateInterval: '主播分成比例应当在0~100之间',
        chooseWorkReleaseRatePlease: '请选择作品发布频率',
        durationMissing: '请输入时长',
        chooseDisplayWayPlease: '请选择演绎方式',
        anchorShareRateMissing: '请填写给主播的分成比例',
        briefShouldLessThan2Thousand: '简介的字数请不要超过2000',
        dataCommitSuccessfully: '数据提交成功',
        queryByBookNameOrWriterName: '搜索书名／作者名',
        writerMissing: '请填写作家姓名，多位用逗号区隔，例：李白，曹雪芹，杜甫',
        copyrightLimitMissing: '请选择版权截止日期',
        taskTimeLimit: '作品完成时限(天)',
        clickToUploadAuthFile: '点击上传认证文件',
        clickToUploadWork: '点击上传作品',
        suggestedPriceLabel: '该定价策略仅用作喜马拉雅FM付费专辑定价参考',
        removeBookConfirmWithIndex: '确认要放弃上传第{index}本书？',
        NotAPublisher: '对不起，此功能只对出版社开放',
        bookBelongPlaceHolder: '请输入您的代表作',
        phoneNumberPlaceHolder: '请输入联系电话',
        wechatPlaceHolder: '请输入微信号',
        websitePlaceHolder: '请输入官网地址',
        cooperationCommentPlaceHolder: '合作相关说明',
        verifyCodeMissing: '请输入验证码',
        licenseNumberPlaceHolder: '请填写工商注册号码',
        uploadLicensePic: '请上传营业执照',
        publisherNameMissing: '请输入出版社名称',
        publisherLicenseNumberMissing: '请输入出版社编号',
        haveReadAuthorizationDeal: '已阅读授权协议',
        additionLimitMissing: '请选择海选期限',
        workListMissing: '请上传作品内容附件',
        authFileMissing: '请根据模板上传授权文件',
        retrospectFileMissing: '上传版权链接文件，需可追溯到出版信息（含出版合同，带有ISBN信息的版权页资料等）',
    }
}
// {{ $t('sen.haveReadAuthorizationDeal') }}
// this.$i18n.t('sen.NotAPublisher')



// WEBPACK FOOTER //
// ./src/i18n/lang/zh.js